/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cuddly_Deft_Pug_HintInputs */

const fr_cuddly_deft_pug_hint = /** @type {(inputs: Cuddly_Deft_Pug_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon Profil`)
};

/**

* @param {Cuddly_Deft_Pug_HintInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const cuddly_deft_pug_hint = /** @type {((inputs?: Cuddly_Deft_Pug_HintInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cuddly_Deft_Pug_HintInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_cuddly_deft_pug_hint(inputs)
});